import { render, staticRenderFns } from "./StaffReportGeneration.vue?vue&type=template&id=79e701d4&scoped=true&"
import script from "./StaffReportGeneration.vue?vue&type=script&lang=js&"
export * from "./StaffReportGeneration.vue?vue&type=script&lang=js&"
import style0 from "./StaffReportGeneration.vue?vue&type=style&index=0&id=79e701d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e701d4",
  null
  
)

export default component.exports